<template>
    <div :class=[variant]>
        <span role="button" aria-label="Botón de paginación" v-for="pageNumber in totalPages" :key="pageNumber"
            @click="goToPage(pageNumber)" :class="{ active: currentPage === pageNumber }">{{ pageNumber }}</span>
    </div>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'pagination-general'
        },
        totalItems: {
            type: Number,
            required: true,
            default: 100
        },
        itemsPerPage: {
            type: Number,
            default: 10
        },
        currentPage: {
            type: Number,
            default: 1
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        }
    },
    methods: {
        goToPage(pageNumber) {
            if (pageNumber !== this.currentPage) {
                this.$emit('page-changed', pageNumber);
            }
        }
    }
};
</script>

<style>
/* .pagination-table {
    display: flex;
}

.pagination-table span {
    margin: 0 5px;
    font-size: 12px;
    cursor: pointer;
    color: #00C18C;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    text-decoration: underline;
}

.pagination-table span.active {
    font-family: Verdana, Arial, Helvetica, sans-serif;
    text-decoration: none;
    font-weight: bold;
    color: #044A34;
}

.pagination-general {
    display: flex;
}

.pagination-general span {
    margin: 0 5px;
    font-size: 12px;
    padding: 2px 6px;
    cursor: pointer;
    border-radius: 60px;
    color: #FFF;
    font-weight: bold;
    font-family: Arial, sans-serif;
    background: #00805D;
}

.pagination-general span.active {
    background: rgb(137, 187, 51);
}

.pagination-general2 {
    display: flex;
}

.pagination-general2 span {
    margin: 0 5px;
    font-size: 12px;
    padding: 2px 6px;
    cursor: pointer;
    border-radius: 60px;
    color: #FFF;
    font-weight: bold;
    font-family: Arial, sans-serif;
    background: rgb(204, 204, 204);
}

.pagination-general2 span.active {
    background: rgb(170, 170, 170);
} */
</style>